// Maaş / Prim Oluştur (hakediş) penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'personnel.salaryBonus';

export const personnelSalaryBonusGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'Maaş / prim hakedişi nasıl oluşturulur?'),
  intro: t(`${G}.intro`, 'Personelin hak ettiği maaşı veya primi deftere "hakediş" olarak yazarsınız. Ödemeyi daha sonra "Maaş Ödemesi Yap" / "Prim Ödemesi Yap" ile yaparsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Maaş Oluştur / Prim Oluştur'),
    tabs: t(`${G}.regions.tabs`, 'Maaş / Prim sekmeleri'),
    body: t(`${G}.regions.body`, 'Hakediş formu'),
    footer: t(`${G}.regions.footer`, 'Oluştur ve Öde / Oluştur'),
  },
  navItems: [
    t(`${G}.nav.salary`, 'Maaş'),
    t(`${G}.nav.bonus`, 'Prim'),
  ],
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Hakediş ne demek?'),
      text: t(`${G}.s1.text`, 'Hakediş, şirketin personele borçlandığını gösteren kayıttır; para hareketi oluşturmaz, kasa ve banka bakiyeleri değişmez. Personel Hareketlerinde "Şirket Borcu (Personel Alacağı)" olarak görünür ve Güncel Bakiye tutar kadar azalır.'),
    },
    {
      region: 'tabs',
      title: t(`${G}.s2.title`, '2. Maaş mı, prim mi?'),
      text: t(`${G}.s2.text`, 'Üstteki "Maaş" veya "Prim" sekmesini seçin. Sekme değişince açıklama "… için maaş hakedişi" ya da "… için prim hakedişi" olarak yeniden doldurulur. Avans kontrolü yalnız Maaş sekmesinde yapılır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Tarih, para birimi ve tutar'),
      text: t(`${G}.s3.text`, '"İşlem Tarihi" hakedişin deftere yazılacağı tarihtir; geçmiş bir tarih seçebilirsiniz. Para birimini (Türk Lirası, Amerikan Doları, Euro, İngiliz Sterlini) seçin ve "Maaş Tutarı" / "Prim Tutarı" alanına sıfırdan büyük bir tutar girin. Açıklamayı isterseniz değiştirin.'),
      tips: [
        t(`${G}.s3.tip1`, '"Proje (opsiyonel)" seçerseniz hakediş o projeye maliyet olarak işlenir. Şube yöneticisinde bu alan görünmez.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Oluşturun ve avansı mahsup edin'),
      text: t(`${G}.s4.text`, '"Maaş Oluştur" / "Prim Oluştur" hakedişi kaydeder. Maaşta önce son maaş hakedişinden bu yana (yoksa bugüne kadar) aynı para biriminde verilen avanslar aranır; bulunursa "Avans Uyarısı" açılır ve "Avans maaştan düşülsün mü?" diye sorulur.'),
      tips: [
        t(`${G}.s4.tip1`, '"Evet, Maaştan Düş": hakediş avans kadar düşük oluşturulur, açıklamasına "(… avans düşüldü)" eklenir ve para hareketi olmadan bir "Avans mahsubu" tahsilat kaydı yazılır.'),
        t(`${G}.s4.tip2`, '"Düşme, Tam Tutar Oluştur": hakediş girdiğiniz tutarla oluşturulur. Avans toplamı maaşa eşit veya büyükse otomatik düşüm yapılamaz.'),
        t(`${G}.s4.tip3`, 'İki seçenekte de personelin Güncel Bakiyesi aynı sonuca çıkar; fark, sonradan ödenecek hakediş tutarıdır.'),
        t(`${G}.s4.tip4`, 'Avans sayılan ödemeler: "Avans Ver" ile yapılanlar ve açıklamasında "avans" geçen, hakedişe bağlı olmayan ödemeler.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. "Oluştur ve Öde" düğmesi'),
      text: t(`${G}.s5.text`, 'Tutar girilince "Oluştur ve Öde" düğmesi görünür. Önce hakediş oluşturulur (maaşta avans uyarısı da sorulur), ardından bu hakedişe bağlı "Personele Ödeme Yap" penceresi açılır. Ödemeyi yapmadan kapatırsanız hakediş "Ödenmedi" olarak kalır; sonra ⋮ menüsündeki "Maaş Ödemesi Yap" / "Prim Ödemesi Yap" ile ödersiniz.'),
    },
  ],
});
